import React from 'react';
import { Product } from '../types/types';
import { ProductCard } from './ProductCard';
interface MenuSectionProps {
  title: string;
  products: Product[];
  onAddProduct: (product: Product) => void;
}
export function MenuSection({
  title,
  products,
  onAddProduct
}: MenuSectionProps) {
  if (products.length === 0) return null;
  return <div className="mb-8" data-id="element-230">
      <h2 className="text-xl font-heading font-bold text-gray-900 mb-4 px-1" data-id="element-231">
        {title}
      </h2>
      <div className="grid grid-cols-2 gap-3" data-id="element-232">
        {products.map(product => <ProductCard key={product.id} product={product} onAdd={onAddProduct} data-id="element-233" />)}
      </div>
    </div>;
}